import { match as RouterMatch } from 'react-router';

export const getParamFromRouteMatch = (
  match?: RouterMatch | null,
  paramName: string = ''
) => {
  const params = (match && match.params) || {};
  return params[paramName as keyof typeof params] || '';
};
